export default __webpack_public_path__ + "static/media/serenad1.a5af0f37.png";